import styled from 'styled-components'

const Hero = styled.section`
    position: relative;
    margin-top: -4rem;
    height: ${props => (props.single ? '40rem' : '45rem')};
    overflow: hidden;
    margin-bottom: ${props => (props.single ? '4rem' : '6rem')};
    @media (max-width: ${props => props.theme.breakpoints.laptop}), (max-device-width: ${props => props.theme.breakpoints.laptop}) {
        height: ${props => (props.single ? '30rem' : '40rem')};
    }
    @media (max-width: ${props => props.theme.breakpoints.m}), (max-device-width: ${props => props.theme.breakpoints.m}) {
        height: ${props => (props.single ? '30rem' : '35rem')};
    }
    @media (max-width: ${props => props.theme.breakpoints.s}), (max-device-width: ${props => props.theme.breakpoints.s}) {
        height: ${props => (props.single ? '25rem' : '25rem')};
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) and (orientation: landscape), (max-device-width: ${props => props.theme.breakpoints.s}) and (orientation: landscape) {
            height: 25rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.xs}), (max-device-width: ${props => props.theme.breakpoints.xs}) {
        height: ${props => (props.single ? '22rem' : '25rem')};
        margin-top: -5rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.xxs}), (max-device-width: ${props => props.theme.breakpoints.xxs}) {
        height: ${props => (props.single ? '25rem' : '25rem')};
        margin-top: -5rem;
    }
`

export default Hero
